import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import ButtonComponent from "../ButtonComponent";


const SavingButton = ({ isSaving }: { isSaving: boolean }) => {
    const [dots, setDots] = useState("");

    useEffect(() => {
        if (!isSaving) return;

        const interval = setInterval(() => {
            setDots((prev) => (prev.length < 3 ? prev + "." : ""));
        }, 500);

        return () => clearInterval(interval);
    }, [isSaving]);

    return (
        <ButtonComponent
            titel={isSaving ? `Saving${dots}` : "Save"}
            isDisabled={isSaving}
            icon={isSaving && <FontAwesomeIcon icon={faSpinner} spin />}
        />
    );
};

export default SavingButton;
